import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/nbci/usdeclarations'
import pathMap from 'src/paths/pathMap'

class UsDeclarationsRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.US_DECLARATIONS_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.US_DECLARATIONS_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.US_DECLARATIONS_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.US_DECLARATIONS_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default UsDeclarationsRoute
